<template>
  <div>
    <img src="../assets/back.png" @click="$router.go(-1)" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
img {
  position: fixed;
  left: 20px;
  top: 20px;
}
</style>
